import React, { useState } from "react";
import axios from "axios";


const useArticleManagement = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getArticleManagement = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/dynamicWebsite/frontend/blog', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postArticleManagement = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/dynamicWebsite/backend/contact',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchArticleManagement = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/dynamicWebsite/backend/blog',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteArticleManagement = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/dynamicWebsite/backend/blog',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const patchAppointmentclick = (data)=>{
        onBefore({
            axiosMode: "patchClick"
        })
        axios.patch('/dynamicWebsite/backend/blog',
                data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patchClick",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patchClick",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patchClick",
                        status: "error"
                    }
                )
            })
    }
    return {
        ArticleManagement: data,
        getArticleManagement,
        postArticleManagement,
        patchArticleManagement,
        deleteArticleManagement,
        patchAppointmentclick
    }
}
export { useArticleManagement }
